import type { AssetTypeEditButtonProps } from "./asset-type-edit-button.type";

import AssetTypeForm from "@/features/AssetTypes/AssetTypeForm";
import ModelEditButton from "@/modules/model-edit-button";
import { useSidePanel } from "@/modules/side-panel";

const AssetTypeEditButton = ({
  assetType,
  ...buttonProps
}: AssetTypeEditButtonProps) => {
  const { openSidePanel } = useSidePanel();

  const onClick = () => {
    openSidePanel({
      title: assetType.name,
      component: <AssetTypeForm assetTypeId={assetType.id} />,
    });
  };

  return (
    <ModelEditButton {...buttonProps} item={assetType} onClick={onClick} />
  );
};

export default AssetTypeEditButton;
